import { useRef, useState } from "react";
import { BsChevronDown, BsEnvelope, BsFileEarmark, BsPaperclip, BsSafe2 } from "react-icons/bs";
import ArrowDown from "../../../assets/svg/arrow-down.icon";
import ExclamationLg from "../../../assets/svg/exclamation-lg.icon";
import useOutsideClick from "../../../hooks/useOutsideClick";
import { EPriority } from "../../../interfaces/Priority";
import { getItem } from "../../../utilities/localStore/indexDBCalls";
import FilePickerDialog, { iTempStoreFile } from "../../Generic/FilePickerDialog/FilePickerDialog";
import "../Workflow.scss";
const pako = require("pako");
const zip = require("jszip")();
type barProps = {
    uploadFunction: Function;
    embedMessageFunction?: () => void | undefined;
    onPriorityChange: (name: EPriority) => void;
    emailPriority: EPriority;
    uploadTempStoreFunction: (files: FileList) => {};
};

function EmailToolBar(props: barProps) {
    const fileDropdownRef = useRef<HTMLDivElement>(null);
    const fileButtonRef = useRef<HTMLButtonElement>(null);
    const [showAttachMenu, setShowAttachMenu] = useState(false);
    const [showFilePicker, setShowFilePicker] = useState(false);
    const ShowFileDropdown = () => {
        setShowAttachMenu(true);
    };
    const HideFileDropdown = () => {
        setShowAttachMenu(false);
    };

    const openFileDialogue = () => {
        HideFileDropdown();
        props.uploadFunction();
    };
    const embedMessage = () => {
        HideFileDropdown();
        props.embedMessageFunction!();
    };

    const uploadFromTempstore = async (tempStoreFiles: iTempStoreFile[]) => {
        try {
            const dataTransfer = new DataTransfer();
            for (const tempStoreFile of tempStoreFiles) {
                const blobRecord = await getItem("Blobs", tempStoreFile.id);
                if (!blobRecord) {
                    alert("File data not found.");
                    continue;
                }
                const unZippedFIle = await pako.ungzip(blobRecord.data);

                const file = new File([unZippedFIle], tempStoreFile.name, {
                    type: tempStoreFile.mimeType,
                    lastModified: Date.now(),
                });
                dataTransfer.items.add(file);
            }
            const customFileList: FileList = dataTransfer.files;
            props.uploadTempStoreFunction(customFileList);
        } catch (err) {
            alert("An error occured: " + err);
        }
    };

    useOutsideClick(fileDropdownRef, HideFileDropdown);

    return (
        <>
            <div style={{ border: "solid 1px #EDEDED", padding: "3px", paddingBottom: "3px", width: "78px" }}>
                <div style={{ display: " grid", columnGap: "0px", gridTemplateColumns: "20px 20px 28px 55px" }}>
                    <button
                        onClick={() => props.onPriorityChange(EPriority.LOWEST)}
                        className={`email-priority low${props.emailPriority > EPriority.NORMAL ? " active" : ""}`}
                    >
                        <i>
                            <ArrowDown className="priority-icon" />
                        </i>
                    </button>
                    <button
                        onClick={() => props.onPriorityChange(EPriority.HIGHEST)}
                        className={`email-priority high${props.emailPriority < EPriority.NORMAL ? " active" : ""}`}
                    >
                        <i>
                            <ExclamationLg className="priority-icon" />
                        </i>
                    </button>

                    <button
                        className="email-priority normal"
                        onClick={ShowFileDropdown}
                        style={{ border: "0px solid red", paddingLeft: "0px", paddingRight: "0px", margin: "0px" }}
                        ref={fileButtonRef}
                    >
                        <BsPaperclip style={{ width: "12px" }}></BsPaperclip>{" "}
                        <BsChevronDown style={{ width: "10px" }}></BsChevronDown>
                    </button>
                </div>
                {showAttachMenu && (
                    <div
                        className="tlbar-dropdown-list"
                        ref={fileDropdownRef}
                    >
                        <div
                            onClick={openFileDialogue}
                            className="tlbar-optn"
                        >
                            <BsFileEarmark className="tlbar-optn-icon" />
                            <label className="tlbar-optn-label">Insert Files from folders</label>
                        </div>

                        <div
                            onClick={() => {
                                setShowFilePicker(true);
                            }}
                            className="tlbar-optn"
                        >
                            <BsSafe2 className="tlbar-optn-icon" />
                            <label className="tlbar-optn-label">Insert Files from Temp Store</label>
                        </div>
                        <div
                            onClick={embedMessage}
                            className="tlbar-optn"
                            style={{
                                opacity: props.embedMessageFunction == undefined ? "0.7" : "1",
                                pointerEvents: props.embedMessageFunction == undefined ? "none" : "all",
                            }}
                        >
                            <BsEnvelope className="tlbar-optn-icon" />
                            <label className="tlbar-optn-label">Insert Messages from Enquiry</label>
                        </div>
                    </div>
                )}
            </div>
            {showFilePicker && (
                <FilePickerDialog
                    onConfirm={async files => {
                        await uploadFromTempstore(files);
                        setShowFilePicker(false);
                    }}
                    onCancel={() => setShowFilePicker(false)}
                />
            )}
        </>
    );
}

export default EmailToolBar;
